module.exports = __webpack_public_path__ + "static/AvenirNext-Bold-c6525bfe2d61a11b287f37abb31dc659.woff";